import { useMobileQuery } from 'common-front/src/hooks/useMobileQuery';
import { useUserContext } from 'common-front/src/userContext';
import { LocalStorageKeys } from 'common-front/src/util/localStorage';
import { CommonEnvVars } from 'common/src/envVars';
import { useLocalStorage } from 'common/src/util/dependencies/dependencies';
import { isNonEmptyString } from 'common/src/util/string';
import { noop } from 'lodash-es';
import * as React from 'react';

interface IHubSpotContext {
    active: boolean;
    enable: () => void;
    disable: () => void;
}

const HubSpotContext = React.createContext<IHubSpotContext>({
    active: false,
    enable: noop,
    disable: noop
});

function useHubSpotContext(): IHubSpotContext {
    return React.useContext(HubSpotContext);
}

export const HubSpotProvider = ({ children }: { children: React.ReactNode }) => {
    const [active, setActive] = React.useState(true);
    const enable = () => {
        setActive(true);
    };
    const disable = () => {
        setActive(false);
    };

    return (
        <HubSpotContext.Provider value={{ active, enable, disable }}>
            <HubspotWidgetController />
            {children}
        </HubSpotContext.Provider>
    );
};

const HubspotWidgetController = () => {
    const { user } = useUserContext();
    const onMobile = useMobileQuery();
    const localStorage = useLocalStorage();
    const { active } = useHubSpotContext();

    React.useEffect(() => {
        if (CommonEnvVars.USE_HUBSPOT && isNonEmptyString(user?.hubspotToken)) {
            (window as any).hsConversationsSettings = {
                identificationEmail: user!.email,
                identificationToken: user!.hubspotToken
            };

            try {
                if (
                    onMobile ||
                    localStorage.getItem(LocalStorageKeys.HIDE_HUBSPOT) === 'true' ||
                    !active
                ) {
                    const { loaded }: { loaded: boolean } = (
                        window as any
                    ).HubSpotConversations.widget.status();
                    if (loaded) {
                        (window as any).HubSpotConversations.widget.remove();
                    } else {
                        (window as any).HubSpotConversations.on('widgetLoaded', () => {
                            (window as any).HubSpotConversations.widget.remove();
                        });
                    }
                } else {
                    (window as any).HubSpotConversations.clear({ resetWidget: true });
                }
            } catch {
                // Do nothing. In presence of ad-blockers, calls fail and would lead to a blank page.
            }
        }
    }, [onMobile, active]);

    return null;
};
